<template>
    <v-container class="events-page" grid-list-xl fluid ma-0 pa-0>
      <!-- Main Content -->
      <v-row>
        <v-col cols="12">
          <v-card class="main-content-card glossy-card" elevation="8">
            <v-layout justify-center wrap>

              <v-flex xs12 md12>
                <v-col cols="12" class="d-flex justify-center pa-0 mb-n2">
                  <v-card class="d-flex align-center banner-card glossy-card" elevation="0" style="width: 70%">
                    <!-- <v-img :src="require('@/assets/banner/events.jpg')" class="banner-image" /> -->
                    <!-- <v-img style="max-width: 30%" :src="require('@/assets/reserve.png')" @click="register()" class="reserve-button" /> -->
                  </v-card>
                </v-col>


                <v-col cols="12" class="d-flex justify-center pa-0">
                  <v-card class="pongal-image-card glossy-card" elevation="0" style="width: 90%">
                    <v-img
                      src="https://cltts-gallery.s3.amazonaws.com/banners/cv_2026.jpeg"
                      class="pongal-image"
                      max-height="100%"
                    />
                  </v-card>
                </v-col>

                <v-col cols="12" class="d-flex justify-center pa-1">
                  <v-card class="content-section glossy-card pa-0" elevation="0">
                      <v-layout justify-center wrap>
                        <v-flex xs12 md12>
                          <h2 class="event-title gradient-text">Chithirai Thiru Vizha 2026</h2>
                          <v-card class="info-card glossy-card pa-2 mb-1" style="max-width: 100%" elevation="3">
                            <div class="tamil-text">
                              நமது சார்லட் தமிழ்ச் சங்கத்தின் 2026 ஆண்டிற்கான சித்திரை
                              திருவிழா வரும் மே 9th ஆம் தேதி சனிக்கிழமை அன்று <b class="highlight-text">இந்து சென்டர் (முகவரி: 7400 City View
                              Drive, Charlotte NC 28212)</b> அரங்கத்தில் வாழை இலை விருந்துடன்
                              சிறப்பாக நடத்தவுள்ளோம்.<br /><br />
                              உறுப்பினர்கள் தங்கள் திறனை வெளிப்படுத்தும் வகையில் ஆடல், பாடல்,
                              நாடகம், இசைக்கருவிகள் வாசித்தல் போன்ற பல்சுவை நிகழ்ச்சிகள்
                              மற்றும் போட்டிகளில் பங்கேற்று இந்த விழாவினை சிறப்பிக்குமாறு
                              சார்லட் தமிழ்ச் சங்கம் பணிவன்போடு கேட்டுக்கொள்கிறது.<br />
                            </div><br />
                          </v-card>
                          <v-card class="links-card glossy-card pa-2 mb-1" style="max-width: 100%" elevation="3">
                            <!-- Membership Header -->
                            <div class="membership-header">
                              <div class="header-content">
                                <v-icon color="white" size="28" class="header-icon">mdi-account-star</v-icon>
                                <div class="header-text-wrapper">
                                  <span class="header-title">2026 Charlotte Tamil Sangam Membership</span>
                                </div>
                                <a href="https://tinyurl.com/yrwxmt4y" target="_" class="membership-action-btn">
                                  <span>Join Now</span>
                                  <v-icon color="white" size="16" class="ml-1">mdi-arrow-right</v-icon>
                                </a>
                              </div>
                            </div>

                            <!-- Reservation Notice -->
                            <v-col cols="12" md="8" class="pa-0 mt-2 mb-2">
                              <v-card class="d-flex align-left elevation-0 glossy-card pa-2" style="max-width: 100%">
                                <div class="reservation-text">Reserve Now</div>
                                <v-img style="max-width: 40%; border-radius: 12px; overflow: hidden; cursor: pointer;" :src="require('@/assets/viv_book.jpg')" @click="goToVIV" />
                              </v-card>
                            </v-col>

                            <!-- Important Dates Header -->
                            <div class="dates-header">
                              <div class="header-content">
                                <v-icon color="white" size="28" class="header-icon">mdi-calendar-clock</v-icon>
                                <span class="header-title">Important Dates</span>
                              </div>
                            </div>

                            <div class="important-dates">
                              <div class="date-item">STEP 1: Program Registration: March 16th – March 28th</div>
                              <div class="date-item">STEP 2: Participant Registration: March 16th – April 11th</div>
                              <div class="date-item">STEP 3: Audio File Submission: March 16th – April 11th</div>
                              <div class="note-text">NOTE : These deadlines will work for all the other competitions as well, like cooking, kolam etc.</div>
                            </div>

                            <div class="registration-details">
                              <div class="registration-header">
                                <div class="header-content">
                                  <v-icon color="white" size="28" class="header-icon">mdi-clipboard-text</v-icon>
                                  <span class="header-title">Chithirai Thiru Vizha Registration Details</span>
                                </div>
                              </div>

                              <!-- Registration Links Grid -->
                              <v-row class="registration-grid">
                                <!-- Program Guidelines -->
                                <v-col cols="12" md="6" class="pa-1">
                                  <a href="https://docs.google.com/document/d/1Jquv0qQ9Em6ge68UccPDKKmBvtoArxNy/edit?usp=drivesdk&ouid=117246728464325176810&rtpof=true&sd=true" target="_" class="registration-link-card">
                                    <div class="link-icon-wrapper purple-gradient">
                                      <v-icon color="white" size="24">mdi-file-document</v-icon>
                                    </div>
                                    <div class="link-content">
                                      <div class="link-title">Program Guidelines</div>
                                      <div class="link-subtitle">View event guidelines</div>
                                    </div>
                                    <v-icon color="#667eea" size="20">mdi-arrow-right</v-icon>
                                  </a>
                                </v-col>

                                <!-- Cultural Program -->
                                <v-col cols="12" md="6" class="pa-1">
                                  <a href="https://docs.google.com/forms/d/e/1FAIpQLSdr9ha4lHR2wILntOUeIkGVpCwTbYWOnzgLzXIIV_fJBCBJYQ/viewform?usp=sharing&ouid=117246728464325176810" target="_" class="registration-link-card">
                                    <div class="link-icon-wrapper blue-gradient">
                                      <v-icon color="white" size="24">mdi-music</v-icon>
                                    </div>
                                    <div class="link-content">
                                      <div class="link-title">Cultural Program Enrollment</div>
                                      <div class="link-subtitle">Register for cultural events</div>
                                    </div>
                                    <v-icon color="#667eea" size="20">mdi-arrow-right</v-icon>
                                  </a>
                                </v-col>

                                <!-- Participation Registration -->
                                <v-col cols="12" md="6" class="pa-1">
                                  <a href="https://docs.google.com/forms/d/e/1FAIpQLSeXr2XUVK08_EcHpKmWqxXP5B1vc_ROVO_nuNtnRoulj5eTrQ/viewform?usp=sharing&ouid=117246728464325176810" target="_" class="registration-link-card">
                                    <div class="link-icon-wrapper green-gradient">
                                      <v-icon color="white" size="24">mdi-account-check</v-icon>
                                    </div>
                                    <div class="link-content">
                                      <div class="link-title">Participation Registration</div>
                                      <div class="link-subtitle">Register participants</div>
                                    </div>
                                    <v-icon color="#667eea" size="20">mdi-arrow-right</v-icon>
                                  </a>
                                </v-col>

                                <!-- Audio Track -->
                                <v-col cols="12" md="6" class="pa-1">
                                  <a href="https://docs.google.com/forms/d/e/1FAIpQLScxV1qd3p8AFpVmproM96_0K8j4GzGcLuCvU7U5YWuGhzybFA/viewform?usp=sharing&ouid=117246728464325176810" target="_" class="registration-link-card">
                                    <div class="link-icon-wrapper orange-gradient">
                                      <v-icon color="white" size="24">mdi-music-note</v-icon>
                                    </div>
                                    <div class="link-content">
                                      <div class="link-title">Audio Track Submission</div>
                                      <div class="link-subtitle">Submit your audio files</div>
                                    </div>
                                    <v-icon color="#667eea" size="20">mdi-arrow-right</v-icon>
                                  </a>
                                </v-col>

                                <!-- Vegetable Carving -->
                                <v-col cols="12" md="6" class="pa-1">
                                  <a href="https://docs.google.com/forms/d/e/1FAIpQLSfQaQUwc1m5a6voaGK3N_DNEhpsPofgSNXXynk6pcGo_MLAdA/viewform?usp=sharing&ouid=117246728464325176810" target="_" class="registration-link-card">
                                    <div class="link-icon-wrapper red-gradient">
                                      <v-icon color="white" size="24">mdi-food-apple</v-icon>
                                    </div>
                                    <div class="link-content">
                                      <div class="link-title">Vegetable Carving Competition</div>
                                      <div class="link-subtitle">Register for carving contest</div>
                                    </div>
                                    <v-icon color="#667eea" size="20">mdi-arrow-right</v-icon>
                                  </a>
                                </v-col>

                                <!-- Volunteer Sign up -->
                                <v-col cols="12" md="6" class="pa-1">
                                  <a href="https://docs.google.com/forms/d/e/1FAIpQLSczGOVjrRUTqbue7FjWRE8XPHvoQu938NGUHHCljvUEvsniXg/viewform?usp=sharing&ouid=117246728464325176810" target="_" class="registration-link-card">
                                    <div class="link-icon-wrapper cyan-gradient">
                                      <v-icon color="white" size="24">mdi-account-group</v-icon>
                                    </div>
                                    <div class="link-content">
                                      <div class="link-title">Volunteer Sign Up</div>
                                      <div class="link-subtitle">Join as volunteer</div>
                                    </div>
                                    <v-icon color="#667eea" size="20">mdi-arrow-right</v-icon>
                                  </a>
                                </v-col>

                                <!-- EmCee Sign up -->
                                <v-col cols="12" md="6" class="pa-1">
                                  <a href="https://docs.google.com/forms/d/e/1FAIpQLSfO7B08JA2ECcDIGLvlNAHLA_xADZ_zAo3Tj6GK5XV8sCTG5g/viewform?usp=sharing&ouid=117246728464325176810" target="_" class="registration-link-card">
                                    <div class="link-icon-wrapper indigo-gradient">
                                      <v-icon color="white" size="24">mdi-microphone</v-icon>
                                    </div>
                                    <div class="link-content">
                                      <div class="link-title">EmCee Sign Up</div>
                                      <div class="link-subtitle">Volunteer as host</div>
                                    </div>
                                    <v-icon color="#667eea" size="20">mdi-arrow-right</v-icon>
                                  </a>
                                </v-col>

                                <!-- Judge Form -->
                                <v-col cols="12" md="6" class="pa-1">
                                  <a href="https://docs.google.com/forms/d/e/1FAIpQLSdF9rW096s9NYDXcT-0SnmFyHFxe0-rUVGL0kBhoQ7h-z8t4g/viewform?usp=sharing&ouid=117246728464325176810" target="_" class="registration-link-card">
                                    <div class="link-icon-wrapper amber-gradient">
                                      <v-icon color="white" size="24">mdi-gavel</v-icon>
                                    </div>
                                    <div class="link-content">
                                      <div class="link-title">Judge Volunteers</div>
                                      <div class="link-subtitle">Volunteer as judge</div>
                                    </div>
                                    <v-icon color="#667eea" size="20">mdi-arrow-right</v-icon>
                                  </a>
                                </v-col>

                                <!-- Drawing -->
                                <v-col cols="12" md="6" class="pa-1">
                                  <a href="https://docs.google.com/forms/d/e/1FAIpQLSfUH9HO5spcp1gMZgyz440sFCBqykPjAYXNQ8mWRfuHApYSEA/viewform?usp=sharing&ouid=117246728464325176810" target="_" class="registration-link-card">
                                    <div class="link-icon-wrapper pink-gradient">
                                      <v-icon color="white" size="24">mdi-palette</v-icon>
                                    </div>
                                    <div class="link-content">
                                      <div class="link-title">Drawing</div>
                                      <div class="link-subtitle">Register for drawing competition</div>
                                    </div>
                                    <v-icon color="#667eea" size="20">mdi-arrow-right</v-icon>
                                  </a>
                                </v-col>

                                <!-- Feedback Form -->
                                <v-col cols="12" md="6" class="pa-1">
                                  <a href="https://docs.google.com/forms/d/e/1FAIpQLScyelXcKg2-x_sZbakFvhej2aC_WV1wnrh-525UB5m4hyE9kQ/viewform?usp=sharing&ouid=117246728464325176810" target="_" class="registration-link-card">
                                    <div class="link-icon-wrapper lime-gradient">
                                      <v-icon color="white" size="24">mdi-comment-text</v-icon>
                                    </div>
                                    <div class="link-content">
                                      <div class="link-title">Chithirai Thiru Vizha 2026 Feedback</div>
                                      <div class="link-subtitle">Share your feedback</div>
                                    </div>
                                    <v-icon color="#667eea" size="20">mdi-arrow-right</v-icon>
                                  </a>
                                </v-col>
                              </v-row>
                            </div>

                          </v-card>
                          <v-card class="thank-you-card glossy-card pa-2 mt-2" style="max-width: 100%" elevation="0">
                            <div class="thank-you-text">
                              <b>நன்றி.</b><br />
                              <b class="gradient-text">சார்லட் தமிழ்ச் சங்கம்</b><br />
                            </div>
                          </v-card>
                        </v-flex>
                      </v-layout>
                  </v-card>
                </v-col>
              </v-flex>
            </v-layout>
          </v-card>
        </v-col>
      </v-row>
      <br>

      <!-- Sponsors Marquee - visible to everyone -->
      <v-flex xs12 md12>
        <sponsors-marquee></sponsors-marquee>
      </v-flex>

      <v-flex xs12 md12 v-if="isAuthenticated">
        <v-card class="sponsors-section glossy-card pa-4 mb-4" elevation="8">
          <div class="sponsor-header gradient-bg pa-3 mb-3">
            <v-icon left color="white" size="28">mdi-account</v-icon>
            <span class="sponsor-title white--text">Platinum Sponsors</span>
          </div>
          <home-images></home-images>
        </v-card>

        <v-card class="sponsors-section glossy-card pa-4 mb-4" elevation="8">
          <div class="sponsor-header gradient-bg-blue pa-3 mb-3">
            <v-icon left color="white" size="28">mdi-web</v-icon>
            <span class="sponsor-title white--text">Diamond Sponsors</span>
          </div>
          <diamond-sponsors></diamond-sponsors>
        </v-card>

        <extended-footer></extended-footer>
      </v-flex>

    </v-container>
  </template>

  <script>
  import HomeImages from '@/components/HomePageImages'
  import DiamondSponsors from '@/components/DiamondSponsors'
  import SponsorsMarquee from '@/components/SponsorsMarquee'

  export default {
    name: "SectionBlogExcerptLeftImg",
    data() {
      return {
      };
    },
    components: {
      HomeImages,
      DiamondSponsors,
      SponsorsMarquee
    },
    methods: {
      register() {
        this.$router.replace('/PaymentGateway')
      },
      goToVIV() {
        this.$router.push('/VIV')
      }
    },
  };
  </script>
  
  <style lang="scss" scoped>
  // Page Background
  .events-page {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    min-height: 100vh;
    padding: 10px;
    overflow-x: hidden;
    position: relative;

    &::before {
      content: '';
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background:
        radial-gradient(circle at 20% 50%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
        radial-gradient(circle at 80% 80%, rgba(255, 255, 255, 0.1) 0%, transparent 50%);
      pointer-events: none;
      z-index: 0;
    }

    > * {
      position: relative;
      z-index: 1;
    }
  }

  // Glossy Card Effect
  .glossy-card {
    background: rgba(255, 255, 255, 0.95) !important;
    backdrop-filter: blur(10px);
    border-radius: 20px !important;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
      transform: translateY(-3px);
    }
  }

  // Enhanced elevation shadows
  .glossy-card[elevation="3"] {
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.08),
                0 3px 6px rgba(102, 126, 234, 0.1),
                0 0 0 1px rgba(255, 255, 255, 0.5) inset !important;

    &:hover {
      box-shadow: 0 6px 12px rgba(0, 0, 0, 0.12),
                  0 6px 12px rgba(102, 126, 234, 0.15),
                  0 0 0 1px rgba(255, 255, 255, 0.7) inset !important;
    }
  }

  .glossy-card[elevation="4"] {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1),
                0 4px 8px rgba(102, 126, 234, 0.12),
                0 0 0 1px rgba(255, 255, 255, 0.5) inset !important;

    &:hover {
      box-shadow: 0 8px 16px rgba(0, 0, 0, 0.14),
                  0 8px 16px rgba(102, 126, 234, 0.18),
                  0 0 0 1px rgba(255, 255, 255, 0.7) inset !important;
    }
  }

  .glossy-card[elevation="6"] {
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.12),
                0 6px 12px rgba(102, 126, 234, 0.15),
                0 0 0 1px rgba(255, 255, 255, 0.5) inset !important;

    &:hover {
      box-shadow: 0 10px 20px rgba(0, 0, 0, 0.16),
                  0 10px 20px rgba(102, 126, 234, 0.2),
                  0 0 0 1px rgba(255, 255, 255, 0.7) inset !important;
    }
  }

  .glossy-card[elevation="8"] {
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.14),
                0 8px 16px rgba(102, 126, 234, 0.18),
                0 0 0 1px rgba(255, 255, 255, 0.6) inset !important;

    &:hover {
      box-shadow: 0 12px 24px rgba(0, 0, 0, 0.18),
                  0 12px 24px rgba(102, 126, 234, 0.25),
                  0 0 0 1px rgba(255, 255, 255, 0.8) inset !important;
    }
  }

  .glossy-card[elevation="10"] {
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.16),
                0 10px 20px rgba(102, 126, 234, 0.2),
                0 0 0 1px rgba(255, 255, 255, 0.6) inset !important;

    &:hover {
      box-shadow: 0 14px 28px rgba(0, 0, 0, 0.2),
                  0 14px 28px rgba(102, 126, 234, 0.3),
                  0 0 0 1px rgba(255, 255, 255, 0.8) inset !important;
    }
  }

  .glossy-card[elevation="12"] {
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.18),
                0 12px 24px rgba(102, 126, 234, 0.25),
                0 0 0 1px rgba(255, 255, 255, 0.7) inset !important;

    &:hover {
      box-shadow: 0 16px 32px rgba(0, 0, 0, 0.22),
                  0 16px 32px rgba(102, 126, 234, 0.35),
                  0 0 0 1px rgba(255, 255, 255, 0.9) inset !important;
    }
  }

  // Main Content Card
  .main-content-card {
    margin-bottom: 10px;
    max-width: 1400px;
    margin-left: auto;
    margin-right: auto;
    padding: 8px !important;
  }

  // Banner Card
  .banner-card {
    overflow: hidden;

    .banner-image {
      transition: transform 0.3s ease;
      width: 100%;
      height: auto;
      max-height: 120px;
      object-fit: cover;
    }

    .reserve-button {
      cursor: pointer;
      transition: all 0.3s ease;
      height: auto;

      &:hover {
        transform: scale(1.05);
        filter: brightness(1.1);
      }
    }

    &:hover .banner-image {
      transform: scale(1.02);
    }
  }

  // Pongal Image Card
  .pongal-image-card {
    overflow: hidden;
    margin-bottom: 20px;

    .pongal-image {
      transition: transform 0.3s ease;
      width: 100%;
      height: auto;
      max-height: 600px;
      object-fit: contain;
    }

    &:hover .pongal-image {
      transform: scale(1.02);
    }
  }

  // Event Title
  .event-title {
    font-size: 1.5rem;
    font-weight: 700;
    margin-bottom: 8px;
    margin-top: 4px;
    text-align: center;
    line-height: 1.3;
  }

  // Reservation Text
  .reservation-text {
    font-size: 1.5rem;
    font-weight: 700;
    color: #667eea;
    text-align: center;
    padding: 20px;
    flex: 1;
  }

  // Gradient Text
  .gradient-text {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  // Info Card
  .info-card {
    border-left: 5px solid #667eea;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.98), rgba(245, 247, 255, 0.98)) !important;
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: -50%;
      right: -50%;
      width: 200px;
      height: 200px;
      background: radial-gradient(circle, rgba(102, 126, 234, 0.05), transparent);
      border-radius: 50%;
    }

    .tamil-text {
      font-size: 1.05rem;
      line-height: 1.8;
      color: #333;
      word-wrap: break-word;
      overflow-wrap: break-word;
      position: relative;
      z-index: 1;
    }

    .highlight-text {
      color: #764ba2;
      background: linear-gradient(135deg, rgba(102, 126, 234, 0.15), rgba(118, 75, 162, 0.15));
      padding: 3px 10px;
      border-radius: 6px;
      font-weight: 700;
      box-shadow: 0 2px 8px rgba(102, 126, 234, 0.1);
    }
  }

  // Links Card
  .links-card {
    border-left: 5px solid #4CAF50;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.98), rgba(250, 250, 255, 0.98)) !important;

    // Membership Header
    .membership-header {
      background: linear-gradient(135deg, #4CAF50 0%, #388E3C 100%);
      border-radius: 12px;
      padding: 10px 16px;
      margin-bottom: 12px;
      box-shadow: 0 8px 24px rgba(76, 175, 80, 0.3);
      position: relative;
      overflow: hidden;

      &::before {
        content: '';
        position: absolute;
        top: -50%;
        right: -10%;
        width: 200px;
        height: 200px;
        background: radial-gradient(circle, rgba(255, 255, 255, 0.15), transparent);
        border-radius: 50%;
      }

      &::after {
        content: '';
        position: absolute;
        bottom: -30%;
        left: -5%;
        width: 150px;
        height: 150px;
        background: radial-gradient(circle, rgba(255, 255, 255, 0.1), transparent);
        border-radius: 50%;
      }

      .header-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;
        z-index: 1;
        flex-wrap: wrap;
        gap: 12px;
      }

      .header-icon {
        background: rgba(255, 255, 255, 0.2);
        padding: 6px;
        border-radius: 10px;
        backdrop-filter: blur(10px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        flex-shrink: 0;
      }

      .header-text-wrapper {
        flex: 1;
        min-width: 200px;
      }

      .header-title {
        font-size: 1.25rem;
        font-weight: 700;
        color: white;
        text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
        letter-spacing: 0.5px;
      }

      .membership-action-btn {
        display: inline-flex;
        align-items: center;
        padding: 10px 20px;
        background: rgba(255, 255, 255, 0.25);
        border: 2px solid rgba(255, 255, 255, 0.4);
        border-radius: 25px;
        color: white;
        text-decoration: none;
        font-weight: 600;
        font-size: 1rem;
        transition: all 0.3s ease;
        backdrop-filter: blur(10px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

        &:hover {
          background: rgba(255, 255, 255, 0.35);
          border-color: rgba(255, 255, 255, 0.6);
          transform: translateY(-2px);
          box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
        }
      }
    }

    // Dates Header
    .dates-header {
      background: linear-gradient(135deg, #FF9800 0%, #F57C00 100%);
      border-radius: 12px;
      padding: 10px 16px;
      margin-bottom: 12px;
      box-shadow: 0 8px 24px rgba(255, 152, 0, 0.3);
      position: relative;
      overflow: hidden;

      &::before {
        content: '';
        position: absolute;
        top: -50%;
        right: -10%;
        width: 200px;
        height: 200px;
        background: radial-gradient(circle, rgba(255, 255, 255, 0.15), transparent);
        border-radius: 50%;
      }

      &::after {
        content: '';
        position: absolute;
        bottom: -30%;
        left: -5%;
        width: 150px;
        height: 150px;
        background: radial-gradient(circle, rgba(255, 255, 255, 0.1), transparent);
        border-radius: 50%;
      }

      .header-content {
        display: flex;
        align-items: center;
        position: relative;
        z-index: 1;
      }

      .header-icon {
        margin-right: 14px;
        background: rgba(255, 255, 255, 0.2);
        padding: 6px;
        border-radius: 10px;
        backdrop-filter: blur(10px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      }

      .header-title {
        font-size: 1.25rem;
        font-weight: 700;
        color: white;
        text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
        letter-spacing: 0.5px;
      }
    }

    .important-dates {
      margin-top: 8px;

      .date-item {
        padding: 8px 12px;
        margin: 6px 0;
        background: linear-gradient(135deg, rgba(102, 126, 234, 0.08), rgba(118, 75, 162, 0.08));
        border-radius: 10px;
        border-left: 4px solid #667eea;
        font-weight: 500;
        transition: all 0.3s ease;
        position: relative;
        overflow: hidden;

        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          height: 100%;
          width: 4px;
          background: linear-gradient(180deg, #667eea, #764ba2);
          transition: width 0.3s ease;
        }

        &:hover {
          background: linear-gradient(135deg, rgba(102, 126, 234, 0.15), rgba(118, 75, 162, 0.15));
          transform: translateX(8px);
          box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);

          &::before {
            width: 100%;
            opacity: 0.1;
          }
        }
      }

      .note-text {
        margin-top: 8px;
        padding: 8px 12px;
        background: linear-gradient(135deg, rgba(255, 152, 0, 0.08), rgba(255, 193, 7, 0.08));
        border-radius: 8px;
        border-left: 4px solid #ff9800;
        font-style: italic;
        color: #e65100;
        font-weight: 500;
        box-shadow: 0 2px 8px rgba(255, 152, 0, 0.1);
      }
    }

    .registration-details {
      margin-top: 12px;

      // Registration Header
      .registration-header {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        border-radius: 12px;
        padding: 10px 16px;
        margin-bottom: 12px;
        box-shadow: 0 8px 24px rgba(102, 126, 234, 0.3);
        position: relative;
        overflow: hidden;

        &::before {
          content: '';
          position: absolute;
          top: -50%;
          right: -10%;
          width: 200px;
          height: 200px;
          background: radial-gradient(circle, rgba(255, 255, 255, 0.15), transparent);
          border-radius: 50%;
        }

        &::after {
          content: '';
          position: absolute;
          bottom: -30%;
          left: -5%;
          width: 150px;
          height: 150px;
          background: radial-gradient(circle, rgba(255, 255, 255, 0.1), transparent);
          border-radius: 50%;
        }

        .header-content {
          display: flex;
          align-items: center;
          position: relative;
          z-index: 1;
        }

        .header-icon {
          margin-right: 10px;
          background: rgba(255, 255, 255, 0.2);
          padding: 4px;
          border-radius: 8px;
          backdrop-filter: blur(10px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }

        .header-title {
          font-size: 1.05rem;
          font-weight: 700;
          color: white;
          text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
          letter-spacing: 0.5px;
        }
      }

      // Registration Grid
      .registration-grid {
        margin-top: 8px;
      }

      // Registration Link Cards
      .registration-link-card {
        display: flex;
        align-items: center;
        padding: 10px 14px;
        background: linear-gradient(135deg, rgba(255, 255, 255, 0.95), rgba(250, 250, 255, 0.95));
        border-radius: 12px;
        text-decoration: none;
        transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
        border: 2px solid rgba(102, 126, 234, 0.1);
        box-shadow: 0 4px 12px rgba(102, 126, 234, 0.08);
        position: relative;
        overflow: hidden;

        &::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(102, 126, 234, 0.1), transparent);
          transition: left 0.5s ease;
        }

        &:hover {
          transform: translateY(-2px) scale(1.01);
          box-shadow: 0 8px 20px rgba(102, 126, 234, 0.2);
          border-color: rgba(102, 126, 234, 0.4);

          &::before {
            left: 100%;
          }

          .link-icon-wrapper {
            transform: rotate(360deg) scale(1.05);
          }

          .link-title {
            color: #667eea;
          }
        }
      }

      .link-icon-wrapper {
        width: 38px;
        height: 38px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 12px;
        flex-shrink: 0;
        transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      }

      .link-content {
        flex: 1;
        min-width: 0;
      }

      .link-title {
        font-size: 0.95rem;
        font-weight: 600;
        color: #333;
        margin-bottom: 2px;
        transition: color 0.3s ease;
      }

      .link-subtitle {
        font-size: 0.75rem;
        color: #666;
        font-weight: 400;
      }

      // Gradient Icon Backgrounds
      .purple-gradient {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      }

      .blue-gradient {
        background: linear-gradient(135deg, #2196F3 0%, #1976D2 100%);
      }

      .green-gradient {
        background: linear-gradient(135deg, #4CAF50 0%, #388E3C 100%);
      }

      .orange-gradient {
        background: linear-gradient(135deg, #FF9800 0%, #F57C00 100%);
      }

      .red-gradient {
        background: linear-gradient(135deg, #F44336 0%, #D32F2F 100%);
      }

      .pink-gradient {
        background: linear-gradient(135deg, #E91E63 0%, #C2185B 100%);
      }

      .teal-gradient {
        background: linear-gradient(135deg, #009688 0%, #00796B 100%);
      }

      .indigo-gradient {
        background: linear-gradient(135deg, #3F51B5 0%, #303F9F 100%);
      }

      .cyan-gradient {
        background: linear-gradient(135deg, #00BCD4 0%, #0097A7 100%);
      }

      .amber-gradient {
        background: linear-gradient(135deg, #FFC107 0%, #FFA000 100%);
      }

      .deep-purple-gradient {
        background: linear-gradient(135deg, #673AB7 0%, #512DA8 100%);
      }

      .lime-gradient {
        background: linear-gradient(135deg, #CDDC39 0%, #AFB42B 100%);
      }
    }
  }

  // Glossy Links
  .glossy-link {
    color: #667eea !important;
    font-weight: 600;
    text-decoration: none;
    padding: 4px 12px;
    background: linear-gradient(135deg, rgba(102, 126, 234, 0.15), rgba(118, 75, 162, 0.15));
    border-radius: 6px;
    transition: all 0.3s ease;
    display: inline-block;

    &:hover {
      background: linear-gradient(135deg, #667eea, #764ba2);
      color: white !important;
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
    }
  }

  // Thank You Card
  .thank-you-card {
    text-align: center;
    border: 2px solid rgba(102, 126, 234, 0.3);
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.98), rgba(250, 245, 255, 0.98)) !important;
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 300px;
      height: 300px;
      background: radial-gradient(circle, rgba(102, 126, 234, 0.05), transparent);
      border-radius: 50%;
    }

    .thank-you-text {
      font-size: 1.2rem;
      line-height: 2;
      position: relative;
      z-index: 1;
    }
  }

  // Gradient Backgrounds
  .gradient-bg {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 15px;
    box-shadow: 0 8px 20px rgba(102, 126, 234, 0.3);
  }

  .gradient-bg-blue {
    background: linear-gradient(135deg, #2196F3 0%, #1976D2 100%);
    border-radius: 15px;
    box-shadow: 0 8px 20px rgba(33, 150, 243, 0.3);
  }

  // Sponsors Section
  .sponsors-section {
    margin-bottom: 20px;
    max-width: 1400px;
    margin-left: auto;
    margin-right: auto;

    .sponsor-header {
      display: flex;
      align-items: center;

      .sponsor-title {
        font-size: 1.5rem;
        font-weight: 700;
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
      }
    }
  }

  // Responsive Design

  // Large Desktop (1920px and above)
  @media (min-width: 1920px) {
    .events-page {
      padding: 15px;
    }

    .main-content-card {
      max-width: 1600px;
    }

    .sponsors-section {
      max-width: 1600px;
    }
  }

  // Desktop (1280px - 1919px)
  @media (min-width: 1280px) and (max-width: 1919px) {
    .events-page {
      padding: 12px;
    }

    .main-content-card {
      max-width: 1400px;
    }
  }

  // Laptop (1024px - 1279px)
  @media (min-width: 1024px) and (max-width: 1279px) {
    .events-page {
      padding: 10px;
    }

    .main-content-card {
      max-width: 1200px;
    }

    .banner-card {
      width: 60% !important;
    }

    .pongal-image-card {
      width: 85% !important;
    }
  }

  // Tablet (768px - 1023px)
  @media (min-width: 768px) and (max-width: 1023px) {
    .events-page {
      padding: 8px;
    }

    .main-content-card {
      max-width: 100%;
    }

    .banner-card {
      width: 75% !important;
    }

    .pongal-image-card {
      width: 90% !important;
    }

    .event-title {
      font-size: 1.6rem;
    }

    .section-heading {
      font-size: 1.2rem !important;
    }

    .glossy-card {
      margin-bottom: 12px;
    }

    .registration-header {
      .header-title {
        font-size: 1.3rem !important;
      }
    }

    .membership-header {
      .header-title {
        font-size: 1.3rem !important;
      }

      .membership-action-btn {
        font-size: 0.95rem !important;
        padding: 9px 18px !important;
      }
    }

    .dates-header {
      .header-title {
        font-size: 1.3rem !important;
      }
    }
  }

  // Mobile Landscape (600px - 767px)
  @media (min-width: 600px) and (max-width: 767px) {
    .events-page {
      padding: 6px;
    }

    .banner-card {
      width: 85% !important;
    }

    .pongal-image-card {
      width: 95% !important;
    }

    .event-title {
      font-size: 1.4rem;
    }

    .tamil-text {
      font-size: 0.95rem !important;
    }

    .link-item {
      font-size: 0.9rem;
    }
  }

  // Mobile Portrait (below 600px)
  @media (max-width: 599px) {
    // Override all Vuetify spacing
    .container,
    .v-container {
      padding: 0 !important;
      margin: 0 !important;
      max-width: 100% !important;
    }

    .events-page {
      padding: 0 !important;
      margin: 0 !important;
      max-width: 100vw !important;
      overflow-x: hidden;

      .v-row {
        margin: 0 !important;
      }

      .container {
        padding: 0 !important;
        margin: 0 !important;
      }
    }

    .main-content-card {
      width: 100% !important;
      max-width: 100% !important;
      margin: 0 !important;
      padding: 0 !important;
      border-radius: 0 !important;
    }

    .banner-card {
      width: 100% !important;
      flex-direction: column !important;
    }

    .reserve-button {
      max-width: 50% !important;
      margin-top: 10px;
    }

    .pongal-image-card {
      width: 100% !important;
    }

    .event-title {
      font-size: 1.3rem;
    }

    .section-heading {
      font-size: 1.1rem !important;
    }

    .tamil-text {
      font-size: 0.9rem !important;
      line-height: 1.6 !important;
    }

    .membership-link {
      font-size: 0.95rem !important;
    }

    .date-item {
      font-size: 0.85rem;
      padding: 10px 14px !important;
    }

    .glossy-link {
      padding: 3px 8px !important;
      font-size: 0.85rem;
    }

    .sponsor-title {
      font-size: 1.2rem !important;
    }

    .sponsors-section {
      width: 100% !important;
      max-width: 100% !important;
      padding: 8px !important;
      margin: 0 !important;
    }

    .glossy-card {
      margin-bottom: 10px;
      border-radius: 12px !important;
    }

    .v-col {
      padding: 0 !important;

      &.d-flex {
        display: block !important;
      }

      &.justify-center {
        justify-content: flex-start !important;
      }
    }

    .v-layout {
      margin: 0 !important;
    }

    .v-flex {
      padding: 0 !important;
    }

    .content-section {
      width: 100% !important;
      max-width: 100% !important;
      padding: 8px !important;
      margin: 0 !important;
      border-radius: 0 !important;
    }

    .info-card,
    .links-card,
    .thank-you-card {
      padding: 12px !important;
      width: 100% !important;
      max-width: 100% !important;
      margin-left: 0 !important;
      margin-right: 0 !important;
      border-radius: 12px !important;
    }

    // Registration Section Mobile
    .registration-details {
      width: 100% !important;
      margin: 0 !important;
    }

    .registration-grid {
      margin: 0 !important;
      width: 100% !important;
    }

    // Registration Cards Mobile
    .registration-link-card {
      padding: 12px 14px !important;

      .link-icon-wrapper {
        width: 40px !important;
        height: 40px !important;
        margin-right: 12px !important;
      }

      .link-title {
        font-size: 0.95rem !important;
      }

      .link-subtitle {
        font-size: 0.75rem !important;
      }
    }

    // Registration Header Mobile
    .registration-header {
      padding: 16px 18px !important;
      border-radius: 12px !important;

      .header-icon {
        font-size: 24px !important;
        margin-right: 12px !important;
        padding: 6px !important;
      }

      .header-title {
        font-size: 1.1rem !important;
      }
    }

    // Membership Header Mobile
    .membership-header {
      padding: 16px 18px !important;
      border-radius: 12px !important;

      .header-content {
        flex-direction: column !important;
        align-items: flex-start !important;
        gap: 12px !important;
      }

      .header-icon {
        font-size: 24px !important;
        padding: 6px !important;
      }

      .header-text-wrapper {
        min-width: 100% !important;
      }

      .header-title {
        font-size: 1.1rem !important;
      }

      .membership-action-btn {
        padding: 8px 16px !important;
        font-size: 0.9rem !important;
        width: 100%;
        justify-content: center;
      }
    }

    // Dates Header Mobile
    .dates-header {
      padding: 14px 18px !important;
      border-radius: 12px !important;

      .header-icon {
        font-size: 24px !important;
        margin-right: 12px !important;
        padding: 6px !important;
      }

      .header-title {
        font-size: 1.1rem !important;
      }
    }
  }

  // Extra Small Mobile (below 400px)
  @media (max-width: 399px) {
    .events-page {
      padding: 5px;
    }

    .event-title {
      font-size: 1.1rem;
    }

    .tamil-text {
      font-size: 0.85rem !important;
    }

    .date-item,
    .link-item {
      font-size: 0.8rem;
    }
  }

  </style>
  